import React from 'react';
import { TextField, Button, Typography, Grid } from '@material-ui/core';
import ExpansionPanelDataEmployee from './ExpansionPanelDataEmployee';



const ViewRegister = ({
    viewEmployeeRegistration
}) => {
    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <Grid style={styles.GridHeader}>
                    <Button
                        onClick={viewEmployeeRegistration.handleCloseViewRegistration}
                        style={{ textTransform: 'none', marginTop: -7 }}
                    >
                        <Typography style={styles.ButtonColaboradores} >Colaboradores</Typography>
                    </Button>
                    <Typography style={{ ...styles.ButtonColaboradores, marginLeft: 20 }}>{'>'}</Typography>
                    <Typography style={{ ...styles.ButtonColaboradores, marginLeft: 20 }}> {
                        viewEmployeeRegistration.isUpdate ?
                            'Editar'
                            :
                            'Cadastrar'
                    } Colaborador</Typography>
                </Grid>
                <Grid style={styles.GridHeader2}>
                    <Button
                        onClick={viewEmployeeRegistration.handleCloseViewRegistration}
                    >
                        <div style={styles.circle}> &lt;</div>
                    </Button>
                    <Typography style={{ display: 'flex', marginLeft: 15 }}>
                        <a style={styles.RegisterText}>
                            {
                                viewEmployeeRegistration.isUpdate ?
                                    'Editar'
                                    :
                                    'Cadastrar'
                            }

                        </a>
                        <span style={styles.TextHeader}>colaborador</span>
                    </Typography>
                </Grid>

            </Grid>

            <Grid item xs={12}>
                <ExpansionPanelDataEmployee viewEmployeeRegistration={viewEmployeeRegistration} />
            </Grid>

        </Grid>
    );
};

export default ViewRegister;

const styles = {
    GridHeader: {
        display: 'flex'
    },
    GridHeader2: {
        display: 'flex',
        marginTop: 20
    },
    ButtonColaboradores: {
        fontFamily: 'montserrat',
        color: '#4d5058',
        fontWeight: 'bold'
    },
    circle: {
        width: '40px',
        height: '40px',
        backgroundColor: '#474eda',
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '24px',
        color: 'white'
    },
    RegisterText: {
        color: '#474eda',
        fontWeight: 'bold',
        fontSize: 30,
        fontFamily: 'montserrat'
    },
    TextHeader: {
        marginLeft: 10,
        fontSize: 30,
        fontFamily: 'montserrat',
        color: '#283951'
    }
}
